export default {
  view: (state) => {
    return window.sessionStorage.getItem('kepit-view') || state.view;
  },
  account_type: (state) => {
    if (typeof(state.account) != "undefined") {
      return state.account.type;
    }
    return undefined;
  },
  account_default_group: (state) => {
    if (typeof(state.account) != "undefined") {
      if (typeof(state.account.meta) != "undefined") {
        var uuid = state.account.meta.default_group
        if (typeof("uuid") != "undefined") {
          var ret = state.groups_uuid[uuid];
          if (typeof(ret) != "undefined") return ret;
        }
      }
    }
    
    // FIXME: Tässä pitäs ettiä käyttäjän oma grouppi
    return undefined;
  },
  groups: (state) => {
    return state.all_groups;
  },
  input_channels: (state) => {
    return state.channelList.filter((id) => {
      return state.channels[id].type == "input";
    }).map((id) => { return state.channels[id]; });
  },
  output_channels: (state) => {
    return state.channelList.filter((id) => {
      return state.channels[id].type == "output";
    }).map((id) => { return state.channels[id]; });
  },
  instance_for_channel: (state) => (channel) => {
    if(typeof(channel) != "object" || typeof(channel.uuid) == "undefined" || channel.uuid == "") return undefined;
    var ret = _.find(state.instances, (instance) => {
      var meta = instance.meta || {};
      return meta.channel == channel.uuid;
    });
    return ret;
  },
  instance_for_event: (state) => (event) => {
    if(typeof(event) != "object" || typeof(event.uuid) == "undefined" || event.uuid == "") return undefined;
    var ret = _.find(state.instances, (instance) => {
      var meta = instance.meta || {};
      var events = meta.events || [];
      return events.includes(event.uuid);
    });
    return ret;
  },
  get_session_online_at: (state, getters) => (id) => {
    var data = state.profile_presence[state.account.id];
    if(typeof(data) == "undefined") return 0;
    var session = data.metas.find((row) => {
      return row.session_id == id;
    });
    if(typeof(session) == "undefined") return 0;
    return session.online_at;
  },
  is_privilege: (state) => (list) => {
    if (typeof(state.account) == "object") {
      return list.indexOf(state.account.type) != -1;
    }
    return undefined;
  }
}
